export const operatorOptions = [
  { key: 'is', text: 'is', value: 'is' },
  { key: 'isAnyOf', text: 'is any of', value: 'is any of' },
];

export const columnOptions = [
  { key: 'category', text: 'Category', value: 'category' },
  { key: 'time', text: 'Time', value: 'time' },
  { key: 'user', text: 'User', value: 'user' },
  { key: 'zone', text: 'Zone', value: 'zone' },
  { key: 'credentials', text: 'Credentials', value: 'credentials' },
];

export const categoryOptions = [
  { key: 'Granted', text: 'Granted', value: 'Granted' },
  { key: 'Denied', text: 'Denied', value: 'Denied' },
  { key: 'Public', text: 'Public', value: 'Public' },
  { key: 'Lockout', text: 'Lockout', value: 'Lockout' },
];

export const credentialsOptions = [
  { key: 'Bluetooth', text: 'Bluetooth', value: 'Bluetooth' },
  { key: 'Card', text: 'Card', value: 'Card' },
  { key: 'FingerPrint', text: 'FingerPrint', value: 'FingerPrint' },
  { key: 'Pin', text: 'Pin', value: 'Pin' },
  { key: 'QrCode', text: 'QrCode', value: 'QrCode' },
  { key: 'Remote', text: 'Remote', value: 'Remote' },
  { key: 'Rex', text: 'Rex', value: 'Rex' },
  { key: 'LicensePlate', text: 'LicensePlate', value: 'LicensePlate' },
];
